import fetch from 'cross-fetch';
import { sameOriginRequestPolicy } from '../actions';
import {
	LoginHubResendConfirmationMailAction,
	LoginHubResendConfirmationMailResponse,
} from './login-hub-resend-confirmation-mail';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export class RemoteLoginHubResendConfirmationMailAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: LoginHubResendConfirmationMailAction = async (): Promise<LoginHubResendConfirmationMailResponse> => {
		const base: string = this.baseUrl || '';

		try {
			const response: Response = await fetch(
				`${base}/api/login-hub/resend-confirmation-mail`,
				{
					...sameOriginRequestPolicy,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					mode: 'cors',
				});

			if (response.status === HTTP_STATUS_NO_CONTENT) {
				return {
					status: HTTP_STATUS_NO_CONTENT,
				};
			}

			if (response.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
				return {
					status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
				};
			}

			return {
				status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
			};
		} catch (e: unknown) {
			throw new Error('unexpected');
		}
	};
}
